import axios from 'axios';


const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');
const API = `${BACKEND_URL}/api`;


// Une liste refusée par les permissions (403) devient une liste vide :
// une page qui combine plusieurs listes reste utilisable.
export const orEmptyIfForbidden = (request) =>
  request.catch((error) => (error.response?.status === 403 ? { data: [] } : Promise.reject(error)));

// Services
export const getServices = () => axios.get(`${API}/services`);


// Quotes
export const createQuote = (data) => axios.post(`${API}/quotes`, data);
export const getQuotes = () => axios.get(`${API}/quotes`);
export const updateQuote = (id, data) => axios.put(`${API}/quotes/${id}`, data);
export const deleteQuote = (id) => axios.delete(`${API}/quotes/${id}`);
export const createProjectFromQuote = (id, data) => axios.post(`${API}/quotes/${id}/project`, data);
export const getCompanySettings = () => axios.get(`${API}/settings/company`);
export const updateCompanySettings = (data) => axios.put(`${API}/settings/company`, data);
export const createManualQuote = (data) => axios.post(`${API}/quotes/manual`, data);
export const saveEstimate = (id, data) => axios.put(`${API}/quotes/${id}/estimate`, data);
export const getEstimatePdf = (id) => axios.get(`${API}/quotes/${id}/estimate.pdf`, { responseType: 'blob' });
export const sendEstimate = (id, data) => axios.post(`${API}/quotes/${id}/estimate/send`, data);

// Cleaning Requests & Part Orders (admin)
export const getCleaningRequests = () => axios.get(`${API}/cleaning-requests`);
export const updateCleaningRequest = (id, data) => axios.put(`${API}/cleaning-requests/${id}`, data);
export const deleteCleaningRequest = (id) => axios.delete(`${API}/cleaning-requests/${id}`);
export const getPartOrders = () => axios.get(`${API}/part-orders`);
export const updatePartOrder = (id, data) => axios.put(`${API}/part-orders/${id}`, data);
export const deletePartOrder = (id) => axios.delete(`${API}/part-orders/${id}`);

// Notifications personnelles (cloche)
export const getMyNotifications = () => axios.get(`${API}/me/notifications`);
export const markMyNotificationsRead = (ids = []) => axios.post(`${API}/me/notifications/read`, { ids });

// Unread (non lu)
export const getUnread = () => axios.get(`${API}/unread`);
export const markUnreadRead = (kind, ids) => axios.post(`${API}/unread/${kind}/read`, { ids });

// Service Requests
export const getAvailability = (date) => axios.get(`${API}/availability/${date}`);
export const createServiceRequest = (data) => axios.post(`${API}/service-requests`, data);
export const getServiceRequests = () => axios.get(`${API}/service-requests`);
export const createManualServiceRequest = (data) => axios.post(`${API}/service-requests/manual`, data);
export const updateServiceRequest = (id, data) => axios.put(`${API}/service-requests/${id}`, data);
export const deleteServiceRequest = (id) => axios.delete(`${API}/service-requests/${id}`);


// Projects
export const createProject = (data) => axios.post(`${API}/projects`, data);
export const getProjects = () => axios.get(`${API}/projects`);
export const getProject = (id) => axios.get(`${API}/projects/${id}`);
export const updateProject = (id, data) => axios.put(`${API}/projects/${id}`, data);
export const deleteProject = (id) => axios.delete(`${API}/projects/${id}`);


// Inventory
export const createInventoryItem = (data) => axios.post(`${API}/inventory`, data);
export const getInventory = () => axios.get(`${API}/inventory`);
export const updateInventoryItem = (id, data) => axios.put(`${API}/inventory/${id}`, data);
export const deleteInventoryItem = (id) => axios.delete(`${API}/inventory/${id}`);


// Equipment
export const createEquipment = (data) => axios.post(`${API}/equipment`, data);
export const getEquipment = () => axios.get(`${API}/equipment`);
export const updateEquipment = (id, data) => axios.put(`${API}/equipment/${id}`, data);
export const deleteEquipment = (id) => axios.delete(`${API}/equipment/${id}`);


// Replacement Requests
export const createReplacementRequest = (data) => axios.post(`${API}/replacement-requests`, data);
export const getReplacementRequests = () => axios.get(`${API}/replacement-requests`);
export const updateReplacementRequest = (id, data) => axios.put(`${API}/replacement-requests/${id}`, data);


// Material Orders
export const createMaterialOrder = (data) => axios.post(`${API}/material-orders`, data);
export const getMaterialOrders = () => axios.get(`${API}/material-orders`);
export const updateMaterialOrder = (id, data) => axios.put(`${API}/material-orders/${id}`, data);


// Time Entries
export const createTimeEntry = (data) => axios.post(`${API}/time-entries`, data);
export const getTimeEntries = () => axios.get(`${API}/time-entries`);
export const updateTimeEntry = (id, data) => axios.put(`${API}/time-entries/${id}`, data);
export const punchIn = (data = {}) => axios.post(`${API}/time-entries/punch-in`, data);
export const punchOut = () => axios.post(`${API}/time-entries/punch-out`);
export const getActiveTimeEntries = () => axios.get(`${API}/time-entries/active`);
export const getVehicleLogs = (params = {}) => axios.get(`${API}/vehicle-logs`, { params });
export const saveVehicleLog = (date, data, employeeId) =>
  axios.put(`${API}/vehicle-logs/${date}`, data, { params: employeeId ? { employee_id: employeeId } : {} });
export const exportVehicleLogs = (params = {}) =>
  axios.get(`${API}/vehicle-logs/export.csv`, { params, responseType: 'blob' });


// Leave Requests
export const createLeaveRequest = (data) => axios.post(`${API}/leave-requests`, data);
export const getLeaveRequests = () => axios.get(`${API}/leave-requests`);
export const updateLeaveRequest = (id, data) => axios.put(`${API}/leave-requests/${id}`, data);


// Employees
export const getEmployees = () => axios.get(`${API}/employees`);
export const getEmployee = (id) => axios.get(`${API}/employees/${id}`);
export const updateEmployee = (id, data) => axios.put(`${API}/employees/${id}`, data);
export const deleteEmployee = (id) => axios.delete(`${API}/employees/${id}`);
export const registerEmployee = (data) => axios.post(`${API}/auth/register`, data);


// Rôles (RBAC)
export const getRoles = () => axios.get(`${API}/roles`);
export const getRoleCatalog = () => axios.get(`${API}/roles/catalog`);
export const createRole = (data) => axios.post(`${API}/roles`, data);
export const updateRole = (key, data) => axios.put(`${API}/roles/${key}`, data);
export const deleteRole = (key) => axios.delete(`${API}/roles/${key}`);

// Dashboard
export const getDashboardStats = () => axios.get(`${API}/dashboard/stats`);


// Password Reset
export const forgotPassword = (email) => axios.post(`${API}/auth/forgot-password`, { email });
export const resetPassword = (token, new_password) => axios.post(`${API}/auth/reset-password`, { token, new_password });

// Inventory usage and billing
export const createMaterialUsage = (data) => axios.post(`${API}/material-usages`, data);
export const getMaterialUsages = (params = {}) => axios.get(`${API}/material-usages`, { params });
export const updateMaterialUsage = (id, data) => axios.put(`${API}/material-usages/${id}`, data);
export const updateMaterialUsageBillingStatus = (data) =>
  axios.post(`${API}/material-usages/billing-status`, data);
export const getInventoryMovements = (itemId) =>
  axios.get(`${API}/inventory/${itemId}/movements`);


// Purchase orders and replenishment
export const getPurchaseOrders = (params = {}) => axios.get(`${API}/purchase-orders`, { params });
export const updatePurchaseOrderStatus = (id, data) =>
  axios.put(`${API}/purchase-orders/${id}/status`, data);
export const adjustPurchaseOrderLines = (id, data) =>
  axios.put(`${API}/purchase-orders/${id}/lines`, data);
export const receivePurchaseOrder = (id, data) =>
  axios.post(`${API}/purchase-orders/${id}/receipts`, data);
export const getInventoryNotifications = () => axios.get(`${API}/notifications`);
